import React from "react";
// import "./home.css";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/riezqidr"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i className="uil uil-instagram"></i>
      </a>

      <a
        href="https://github.com/Rzq12"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i className="uil uil-github-alt"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/riezqidr/"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24" // Adjusted size to match other icons
          height="24"
          viewBox="0 0 144.083 144"
          id="linkedin"
        >
          <path d="M72.041 11.166c-33.543 0-60.833 27.29-60.833 60.834 0 33.545 27.29 60.834 60.833 60.834 33.544 0 60.835-27.289 60.835-60.834-.001-33.544-27.292-60.834-60.835-60.834zm0 115.668c-30.235 0-54.833-24.598-54.833-54.834 0-30.235 24.598-54.834 54.833-54.834S126.876 41.765 126.876 72c-.001 30.236-24.6 54.834-54.835 54.834z"></path>
          <path d="M41.143 59.11h14.078v36.734H41.143z"></path>
          <ellipse cx="48.042" cy="46.75" rx="7.125" ry="6.5"></ellipse>
          <path d="M90.608 58.28c-2.883 0-5.326.525-7.334 1.574-2.006 1.05-3.988 2.796-5.949 5.24V59.11h-13.11v36.734h14.078V78.203c0-3.344.531-5.66 1.592-6.952 1.061-1.291 2.443-1.937 4.15-1.937 1.545 0 2.744.479 3.598 1.436.854.957 1.279 2.588 1.279 4.895v20.199h14.148V72.497c0-4.843-1.102-8.423-3.305-10.741-2.2-2.318-5.251-3.476-9.147-3.476z"></path>
        </svg>
      </a>
    </div>
  );
};

export default Social;
